import { useLocation } from "react-router";
import React, { useMemo } from "react";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Divider } from "@material-ui/core";
import { NavLink } from "react-router-dom/cjs/react-router-dom";
import { checkIsActive, checkIsActiveLink, toAbsoluteUrl } from "../../../_helpers";
import { Col, Row } from "react-bootstrap";
import { KorekApp } from "../../../../app/modules/Web/pages/Home/KorekApp";
import { GetLogo } from "../../../_helpers/GetLogo";
import { shallowEqual, useSelector } from "react-redux";
import { Check } from "@material-ui/icons";
import { FormattedMessage } from "react-intl";

export function Footer() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();
  const location = useLocation();

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true),
    };
  }, [uiService]);

  const getHeaderLogo = () => {
    let result = "logo_white.png";
    if (layoutProps.headerSelfTheme && layoutProps.headerSelfTheme !== "dark") {
      result = "logo_large_1_.png";
    }
    return toAbsoluteUrl(`/media/logos/${result}`);
  };

  const socialMedia = useSelector(
    (state) => state.profileSlice.socialMedia,
    shallowEqual
  );
  return (
    <>
      <KorekApp />
    
    </>
  );
}
